export const HTTP_DOMAIN =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/';
export const PHOTOS_DOMAIN =
  process.env.REACT_APP_PHOTOS_URL || 'http://localhost:8000/storage/';
